import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { BsFillShareFill } from "react-icons/bs";
import { Feature, Loader } from "../../components";
import { useGetUserReposQuery, useGetUserFollowersQuery, useGetUserProfileQuery } from "../../services/gitHubApi";
import PXIframe from "../iframe/Iframe";
import "./users.css";

const buildUrl = (username, repo) => `https://github-readme-stats.vercel.app/api/pin/?username=${username}&repo=${repo}&theme=dracula&title_color=ffffff&text_color=fffff0&icon_color=ffffff&hide_border=true`;
const User = () => {
  const { selectedUser } = useSelector((state) => state.share);
  const { data, isFetching } = useGetUserReposQuery(selectedUser.githubusername);
  const followers = useGetUserFollowersQuery(selectedUser.githubusername);
  const [open, setOpen] = React.useState(false);
  const [url, setUrl] = React.useState("");
  const [reponame, setReponame] = React.useState("");
  const [username, setUsername] = React.useState("");
  const handleClose = () => {
    setOpen(false);
  };
  const githubProfile = useGetUserProfileQuery(selectedUser.githubusername);
  // if (selectedUser !== null) {
  // console.log(githubProfile.data, githubProfile.isFetching);
  // }
  // if (isFetching) return <Loader />;
  const copyLink = () => {
    const el = document.createElement("input");
    el.value = `https://${window.location.hostname}/portfoliax/users`;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    alert("Link Copied");
  };
  const navigateToRepo = (repourl, rep, user) => {
    // window.location.href = `${repourl}`;
    setUrl(repourl);
    setReponame(rep);
    setUsername(user);
    setOpen(!open);
  };
  const handleFollow = (login) => {
    window.location.href = `https://github.com/${login}?tab=followers`;
  };
  if (selectedUser.githubusername === undefined) return <Navigate to="/portfoliax" />;
  return (
    <div>
      <div className="flex w-full justify-center items-center">
        <div className="flex mf:flex-row flex-col items-start justify-between md:p-20 py-12 px-4">
          <div>
            {githubProfile.isFetching ? <Loader /> : (
              <>
                <div className="portfolioX__portfolioX-feature">
                  <Feature
                    title={selectedUser?.githubusername?.toUpperCase()}
                    classX="text-gradient"
                    text=""
                  />
                </div>
                <div className="portfolioX__portfolioX-heading">
                  <h1 className="gradient__text">The possibilities are beyond your imagination
                    <br />
                    <p className="text-3xl sm:text-5xs text-white text-gradient py-1">{selectedUser?.githubusername?.toUpperCase()} Visitor Count On Github</p>
                    <img height="20vh" src={`https://profile-counter.glitch.me/${selectedUser.githubusername}/count.svg`} />
                  </h1>
                  <div className="flex flex-1 pt-5 pl-5 pr-5 justify-start items-start flex-col">
                    <img className="w-full" src={`https://activity-graph.herokuapp.com/graph?username=${selectedUser.githubusername}&theme=dracula&color=B994E6&bg_color=2B2D3D`} />
                  </div>
                </div>
                <img className="w-full" src="https://capsule-render.vercel.app/api?type=waving&color=gradient&height=100&section=footer" />
                <div className="portfolioX__portfolioX-container">
                  <Feature classX="" title="Followers" text={githubProfile.data.followers} />
                  <Feature classX="" title="Following" text={githubProfile.data.following} />
                  <Feature classX="" title="Total Public Repo" text={githubProfile.data.public_repos} />
                  <Feature classX="" title="Total Public Gists" text={githubProfile.data.public_gists} />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="gradient__bg pt-5 rounded">
        <div className="portfolioX__portfolioX section__margin rounded" id="wgpt3">
          <div className="portfolioX__portfolioX-feature">
            <Feature
              title="Github Repos."
              classX="text-gradient"
              text="Latest 8 Github repos."
            />
          </div>
          <div className="portfolioX__portfolioX-container flex">
            {isFetching ? <Loader /> : data.map((repo, i) => (
              <span key={i} onClick={(e) => { e.preventDefault(); navigateToRepo(`https://github.com/${selectedUser.githubusername}/${repo.name}`, repo.name, selectedUser.githubusername); }} className="cursor-pointer">
                <img
                  width="80%"
                  className="m-3"
                  key={i}
                  align="center"
                  src={buildUrl(selectedUser.githubusername, repo.name)}
                />
              </span>
            ))}
          </div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            onClick={handleClose}
          >
            <PXIframe url={url} reponame={reponame} username={username} />
          </Backdrop>
        </div>
        <div className="m-12 p-6 gradient-bg-welcome rounded" id="wgpt3">
          <div className="portfolioX__portfolioX-feature">
            <Feature
              title="Followers"
              classX="text-gradient"
              text="Top 9 Followers"
            />
          </div>
          <div className="portfolioX__portfolioX-container">
            {followers.isFetching ? <Loader /> : followers.data.map((follower, i) => (
              <div key={i} className="m-3 p-3 flex justify-end items-start flex-col rounded-xl h-40 sm:w-72 w-full my-4 eth-card .blue-glassmorphism ">
                <div className="flex justify-between flex-col w-full h-full">
                  <div className="flex justify-between items-start">
                    <div className="w-10 h-10 rounded-full border-2 border-white flex justify-center items-center">
                      <img src={follower.avatar_url} alt="" style={{ height: "35px", width: "35px", borderRadius: "50%" }} />
                    </div>
                    <BsFillShareFill fontSize={17} color="#fff" onClick={copyLink} />
                  </div>
                  <div>
                    <p className="text-white font-light text-sm">
                      {follower.login.toUpperCase()}
                    </p>
                    <p className="text-white font-semibold text-lg mt-1">
                      <div className="bg-[#2952e3] py-2 px-7 mx-4 rounded-full cursor-pointer hover:bg-[#2546bd]" onClick={(e) => { e.preventDefault(); handleFollow(follower.login); }}>
                        Follow on Github
                      </div>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
